<template>
  <div class="p-4 pt-10 sm:p-8 bg-white rounded-lg">
    <div class="animate-pulse w-1/3 bg-gray-50 h-10 mb-2" />
    <div class="animate-pulse w-full bg-gray-50 h-4 mb-1" />
    <div class="animate-pulse w-full bg-gray-50 h-4 mb-1" />
    <div class="animate-pulse w-full bg-gray-50 h-4 mb-1" />
  </div>
</template>
<script lang="ts" setup></script>
